export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-[#FFF8E7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="mb-12">
          <span className="text-xs uppercase tracking-widest text-gray-500 font-medium">
            Sobre el Artista
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="w-full h-[600px]">
            <img
              src="https://static.readdy.ai/image/4b461963755593d5c146d3f2bf08aa37/9ea69f71b37281d03024d03c3baeec49.jpeg"
              alt="David Nieves"
              className="w-full h-full object-cover rounded-2xl shadow-xl"
            />
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-8 leading-tight">
              Una vida dedicada al arte plástico
            </h2>
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-base">
                Fundador de David Nieves Art Gallery, David Nieves es un artista plástico nacido en Ponce, Puerto Rico, con más de una década de trayectoria profesional. Su obra se distingue por la fusión del arte contemporáneo moderno con la abstracción figurativa, desarrollando un lenguaje visual sólido y reconocible.

              </p>
              <p className="text-base">
                Trabaja principalmente con medios mixtos, incorporando acrílico, aerosol, texturas y acabados metálicos, lo que le permite construir composiciones de fuerte presencia visual y profundidad conceptual. Cada pieza explora la emoción, la identidad y la memoria, invitando al espectador a una experiencia introspectiva y sensorial.
              </p>
              <p className="text-base">
                Su práctica artística se enfoca en la creación de obras con propósito, concebidas para trascender lo decorativo y establecer una conexión duradera con el observador. El arte, que transformó su vida, se convierte hoy en un vehículo para narrar historias, sanar emociones y preservar aquello que tiene valor permanente.
David Nieves ofrece obras comisionadas y piezas únicas para colecciones privadas y espacios institucionales, transformando recuerdos, ausencias y emociones en expresiones artísticas atemporales.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}